"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = watchers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/api"));
var actions = _interopRequireWildcard(require("./actions"));
var _ApiConst = require("../../../common/utils/ApiConst");
var _sagas2 = require("../../../astercore/identityService/redux/sagas");
var _utils = require("../../../common/utils/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* addItemsToWishList(params) {
  try {
    yield (0, _effects.put)(actions.ADD_TO_WISH_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.addToWishList, params, tokenData);
    yield (0, _effects.put)(actions.ADD_TO_WISH_LIST_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ADD_TO_WISH_LIST_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getWishList(params) {
  try {
    var _params$data, _mainResponse$body, _params$data2;
    const {
      showLoader = false
    } = params === null || params === void 0 ? void 0 : params.data;
    if ((0, _utils.isMobile)() && showLoader || !(0, _utils.isMobile)()) {
      yield (0, _effects.put)(actions.GET_WISH_LIST_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getWishList, params === null || params === void 0 || (_params$data = params.data) === null || _params$data === void 0 ? void 0 : _params$data.param, tokenData);
    yield (0, _effects.put)(actions.GET_WISH_LIST_API.success(mainResponse));
    const wishListUpdatedData = {
      data: {
        wishListItems: [...(mainResponse === null || mainResponse === void 0 || (_mainResponse$body = mainResponse.body) === null || _mainResponse$body === void 0 ? void 0 : _mainResponse$body.items)]
      }
    };
    yield (0, _effects.call)(_sagas2.updateIdentityLocalData, wishListUpdatedData);
    if (params !== null && params !== void 0 && (_params$data2 = params.data) !== null && _params$data2 !== void 0 && _params$data2.onSuccess) {
      var _mainResponse$body2;
      params.data.onSuccess((_mainResponse$body2 = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.body) !== null && _mainResponse$body2 !== void 0 ? _mainResponse$body2 : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data3;
    yield (0, _effects.put)(actions.GET_WISH_LIST_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data3 = params.data) !== null && _params$data3 !== void 0 && _params$data3.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* removeFromWishList(request) {
  try {
    var _request$data, _request$data2;
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.removeFromWishList, request === null || request === void 0 || (_request$data = request.data) === null || _request$data === void 0 ? void 0 : _request$data.params, tokenData);
    yield (0, _effects.put)(actions.REMOVE_FROM_WISH_LIST_API.success(mainResponse));
    if (request !== null && request !== void 0 && (_request$data2 = request.data) !== null && _request$data2 !== void 0 && _request$data2.onSuccess) {
      request.data.onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _request$data3;
    yield (0, _effects.put)(actions.REMOVE_FROM_WISH_LIST_API.failure(err));
    if (request !== null && request !== void 0 && (_request$data3 = request.data) !== null && _request$data3 !== void 0 && _request$data3.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getWishListSkuIDs(params) {
  try {
    var _params$data4;
    if (!_ApiConst.isThereMobile) {
      yield (0, _effects.put)(actions.GET_WISH_LIST_SKU_IDS_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getWishListSkuIDs, tokenData);
    yield (0, _effects.put)(actions.GET_WISH_LIST_SKU_IDS_API.success(mainResponse));
    if (params !== null && params !== void 0 && (_params$data4 = params.data) !== null && _params$data4 !== void 0 && _params$data4.onSuccess) {
      var _mainResponse$data;
      params.data.onSuccess((_mainResponse$data = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.data) !== null && _mainResponse$data !== void 0 ? _mainResponse$data : {}, mainResponse !== null && mainResponse !== void 0 ? mainResponse : {});
    }
    return mainResponse;
  } catch (err) {
    var _params$data5;
    yield (0, _effects.put)(actions.GET_WISH_LIST_SKU_IDS_API.failure(err));
    if (params !== null && params !== void 0 && (_params$data5 = params.data) !== null && _params$data5 !== void 0 && _params$data5.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeEvery)(actions.ADD_TO_WISH_LIST, addItemsToWishList);
  yield (0, _effects.takeLatest)(actions.GET_WISH_LIST, getWishList);
  yield (0, _effects.takeEvery)(actions.REMOVE_FROM_WISH_LIST, removeFromWishList);
  yield (0, _effects.takeEvery)(actions.GET_WISH_LIST_SKU_IDS, getWishListSkuIDs);
}